import { gql } from '@apollo/client';

export const CHROME = gql`
  query Chrome {
    chrome @client {
      sidebarExpanded
    }
  }
`;

export const TOGGLE_SIDEBAR_EXPANDED = gql`
  mutation ToggleSidebarExpanded {
    toggleSidebarExpanded @client
  }
`;
